import { render, staticRenderFns } from "./KamVerificationDetail.vue?vue&type=template&id=186ae7f8&"
import script from "./KamVerificationDetail.vue?vue&type=script&lang=js&"
export * from "./KamVerificationDetail.vue?vue&type=script&lang=js&"
import style0 from "./KamVerificationDetail.vue?vue&type=style&index=0&id=186ae7f8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports